import {Utils} from '../../app.base'
import {MsgBox, Vue, Routes} from '../../app.vues';

import SwbDevcMaintCheckItemDetail from './DevcMaintCheckItemDetail';
Vue.regist(SwbDevcMaintCheckItemDetail);

import SwbDevcMaintCheckItemSave from './DevcMaintCheckItemSave';
Vue.regist(SwbDevcMaintCheckItemSave);

import SwbDevcMaintCheckItemSelect from './DevcMaintCheckItemSelect';
Vue.regist(SwbDevcMaintCheckItemSelect);

export function saveDevcMaintCheckItemDlg(id, title, callback) {
    title = title != null ? title : '检查项 - 添加';
    Vue.$showDialog({
        title: title,
        width: 800,
        height: 700,
        template: '<swb-check-item-save :id="id" ref="swb_check_item_save"></swb-check-item-save>',
        data: {
            id: id,
        },
        okClicked: function () {
            let result = this.$refs.swb_check_item_save.getDlgResult() || {};
            if (result.type == 'info') {
                callback(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

export function devcMaintCheckItemDetailDlg(id, title, callback) {
    title = title != null ? title : '检查项 - 查看';
    Vue.$showDialog({
        title: title,
        width: 600,
        height: 500,
        template: '<div>' +
        '<swb-check-item-detail :id="id" ref="swb_check_item_detail"></swb-check-item-detail>' +
        '</div>',
        data: {
            id: id,
        },
        okClicked: function () {

        }
    });
}
// 注：  disabledItemIds：  为按照   refSrcId  禁用！！！！！
export function devcMaintCheckItemSelectDlg(multiSelect, initCheckedItem, checkedIds, disabledItemIds, selectOperate, title, callBack) {
    title = (title != null && title != "") ? title : '检查项 - 选择';
    Vue.$showDialog({
        title: title,
        width: -400,
        height: 800,
        template: '<swb-check-item-list-for-select :multiSelect="multiSelect" :selectOperate="selectOperate" :initCheckedItem="initCheckedItem" :checkedIds="checkedIds" :disabledItemIds="disabledItemIds" ref="swb_check_item_list_for_select"></swb-check-item-list-for-select>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            checkedIds: checkedIds,
            selectOperate: selectOperate,
            disabledItemIds: disabledItemIds
        },
        okClicked: function () {
            let result = this.$refs.swb_check_item_list_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}

/**
 *
 * @param multiSelect       // 是否多选
 * @param initCheckedItem   // 单选回显
 * @param checkedIds
 * @param title
 * @param callBack
 */
import SwbDevcMaintProofSelect from './DevcMaintProofSelect';
Vue.regist(SwbDevcMaintProofSelect);
//
export function devcMaintProofForSelectDlg(params, initCheckedItem, checkedIds, isOperator, title, callBack) {
    let multiSelect = params['multiSelect'] || false;
    let appliedWorkType = params['appliedWorkType'];
    //
    title = title != null ? title : '平台保养凭单模板-选择';
    Vue.$showDialog({
        title: title,
        width: 1000,
        height: 700,
        template: '<div>' +
        '<swb-devc-maint-proof-for-select :multiSelect="multiSelect" :initCheckedItem="initCheckedItem" :checkedIds="checkedIds" :isOperator="isOperator" :appliedWorkType="appliedWorkType" ref="swb_devc_maint_proof_for_select"></swb-devc-maint-proof-for-select>' +
        '</div>',
        data: {
            multiSelect: multiSelect,
            initCheckedItem: initCheckedItem,
            checkedIds: checkedIds,
            isOperator: isOperator,
            appliedWorkType: appliedWorkType,
        },
        okClicked: function () {
            let result = this.$refs.swb_devc_maint_proof_for_select.getDlgResult() || {};
            if (result.type == 'info') {
                callBack(result.data);
            } else {
                MsgBox.warning(result.message);
                return false;
            }
            return true;
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/devcMaint/selectDlg.js
// module id = 263
// module chunks = 0